import {useMediaQuery} from 'hooks/useMediaQuery';
import {breakpoints} from 'lib/breakpoints';
import {ComponentProps, FC} from 'react';
import {Link, useInRouterContext} from 'react-router';

import {Icon} from 'components/Icon/Icon';
import {Modal} from 'components/Modal/Modal';
import {Text} from 'components/Text/Text';

import styles from './SignUpLinksModal.module.css';

type Props = {
    shouldShowSignUpButtons?: boolean;
} & ComponentProps<typeof Modal>;

export const SignUpLinksModal: FC<Props> = ({
    shouldShowSignUpButtons = true,
    ...modalProps
}) => {
    const inRouterProvider = useInRouterContext();
    const LinkComponent = inRouterProvider ? Link : 'a';

    const isDesktop = useMediaQuery(breakpoints.up('lg'));

    const TitleComponent = isDesktop ? Text.Bold20 : Text.Bold18;
    return (
        <Modal
            {...modalProps}
            className={styles.modal}
            closeClassName={styles.close}
        >
            <div className={styles.content}>
                <TitleComponent className={styles.title}>
                    Введенный номер не&nbsp;найден в&nbsp;базе наших клиентов
                </TitleComponent>

                <Text.Semibold14 className={styles.subtitle}>
                    Если вы не были ранее зарегистрированы, пройдите процедуру
                    регистрации.
                </Text.Semibold14>

                {shouldShowSignUpButtons && (
                    <div className={styles.controls}>
                        <LinkComponent
                            to="/signup/company"
                            href="/lk/signup/company"
                            className={styles.signUpButton}
                        >
                            <div className={styles.signUpButtonIconBlock}>
                                <Icon name="company" />
                            </div>
                            <Text.Bold14>
                                Зарегистрировать компанию или ИП
                            </Text.Bold14>
                        </LinkComponent>

                        <LinkComponent
                            to="/signup/individual"
                            href="/lk/signup/individual"
                            className={styles.signUpButton}
                        >
                            <div className={styles.signUpButtonIconBlock}>
                                <Icon name="account" />
                            </div>
                            <Text.Bold14>
                                Зарегистрироваться как физлицо
                            </Text.Bold14>
                        </LinkComponent>
                    </div>
                )}
            </div>
        </Modal>
    );
};
